module.exports = __webpack_public_path__ + "img/insights-explore-data.f6d93c34.svg";